module.exports = __webpack_public_path__ + "static/media/10-In-Our-Hands-Zine.7172b70a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/10-In-Our-Hands-Zine.jpg
// module id = 146
// module chunks = 0